import { useCart } from "../context/CartContext";
import { Link } from "react-router-dom";
import "./Cart.scss";

export default function Cart() {
  const { cart, clearCart, updateQuantity, removeFromCart } = useCart();

  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  const formatPrice = (value) =>
    value.toLocaleString("cs-CZ", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

  return (
    <section className="cart">
      <div className="cart__scroller">
        <h1 className="cart__title">Košík</h1>

        {cart.length === 0 ? (
          <p className="cart__empty">Košík je prázdný</p>
        ) : (
          <>
            <ul className="cart__list">
              {cart.map((item) => (
                <li key={item.key} className="cart__item">
                  <img
                    src={item.images?.[0]}
                    alt={item.name}
                    className="cart__thumb"
                    loading="lazy"
                  />

                  <div className="cart__info">
                    <h2 className="cart__name">{item.name}</h2>

                    <div className="cart__meta">
                      {item.size && (
                        <p className="cart__size">Velikost: {item.size}</p>
                      )}
                      <span className="cart__price">
                        {formatPrice(item.price * item.quantity)} Kč
                      </span>
                    </div>
                  </div>

                  <div className="cart__panel">
                    <div className="cart__panel-top">
                      <button
                        type="button"
                        className="cart__qty-btn"
                        onClick={() =>
                          updateQuantity(item.key, item.quantity - 1)
                        }
                        disabled={item.quantity <= 1}
                        aria-label="Snížit množství"
                      >
                        –
                      </button>
                      <span className="cart__qty">{item.quantity}</span>
                      <button
                        type="button"
                        className="cart__qty-btn"
                        onClick={() =>
                          updateQuantity(item.key, item.quantity + 1)
                        }
                        aria-label="Zvýšit množství"
                      >
                        +
                      </button>
                    </div>

                    <div className="cart__panel-bottom">
                      <button
                        type="button"
                        className="cart__remove"
                        onClick={() => removeFromCart(item.key)}
                        aria-label="Odebrat položku"
                      >
                        ✕
                      </button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>

            <p className="cart__total">Celkem: {formatPrice(total)} Kč</p>

            <div className="cart__actions">
              <button
                type="button"
                className="btn btn--secondary"
                onClick={clearCart}
              >
                Vyprázdnit košík
              </button>
              <Link to="/checkout" className="btn btn--primary">
                Pokračovat k objednávce
              </Link>
            </div>
          </>
        )}
      </div>
    </section>
  );
}
